import { FormField, getErrors, Input } from '@maia/ui';
import { useFieldContext } from '../dynamic-form';
import { ComponentProps } from 'react';

type TextFieldProps = {
  moreInfo?: string;
  inputOverrides?: ComponentProps<typeof Input>;
} & Omit<ComponentProps<typeof FormField>, 'inputSlot'>;

export function TextField(props: TextFieldProps) {
  const { inputOverrides, ...rest } = props;
  const field = useFieldContext<string>();

  return (
    <FormField
      {...rest}
      error={getErrors(field)}
      inputSlot={
        <Input
          type="text"
          value={field.state.value}
          onChange={(event) => field.handleChange(event.target.value)}
          {...inputOverrides}
        />
      }
    />
  );
}
